import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './app';

import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { ThemeProvider } from '@material-ui/core';
import themeStyle from './pages/style/themeStyle';
import './index.css'
import { ToastContainer } from 'react-toastify';
import { Global } from '@emotion/react';
library.add(fas, far);

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

export const drawerBleeding = 56;

root.render(
  <ThemeProvider theme={themeStyle}>
    <BrowserRouter>
      <Global
        styles={{
          '.MuiDrawer-root > .MuiPaper-root': {
            height: `calc(20% - ${drawerBleeding}px)`,
            overflow: 'visible',
          },
        }}
      />
      <ToastContainer
        position='top-center'
        autoClose={2500}
        style={{ width: '500px' }}
        limit={1}
      />
      <App />
    </BrowserRouter>
  </ThemeProvider>
);
